import React, { useEffect,useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { showErrorToast, showSuccessToast } from 'components/Toast';
import PrivateRoute from 'components/Navigation/ProtectedRoute';
import BaseInput from 'components/Inputs/BaseInput';
import SolidButton from 'components/SolidButton';

import { REQUIRED_RULE } from 'utils/constants';
import GeneralApi from 'utils/generalApi';
import { useAuth } from 'contexts/Auth';

export default function ChangePasswordAdminPage() {
  const history = useNavigate();
  const auth = useAuth();
  const {
    register,
    watch,
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const generalApi = useMemo(() => new GeneralApi(auth, history), [auth, history]);

  const [loading, setLoading] = useState(false);
  const [loadingEmail, setLoadingEmail] = useState(false);
     /** 🔹 Llamar API al cargar la página */
    useEffect(() => {
      const fetchConfigCorreo = async () => {
        try {
          const response: any = await generalApi.post('/users/config-correo', {
            accion: 'L',
            type: 'subsidy',
          });
          console.log(response);
          if (response?.data?.status && response?.data?.config?.email_notification) {
            setValue('email_notication', response.data.config.email_notification);
          } else {
            showErrorToast('No se pudo obtener el correo de notificaciones');
          }
        } catch (err) {
          showErrorToast('Error al cargar el correo de notificaciones');
        }
      };
  
      fetchConfigCorreo();
    }, [generalApi, setValue]);

  const saveData = async (data: any) => {
    setLoading(true);
    let result: any = await generalApi.put('/users/password', data);
    setLoading(false);
    if (!result.success) return showErrorToast(result.message);
    showSuccessToast('Contraseña cambiada correctamente');
    history('/users');
  };

 const saveEmail = async () => {
    const email_notification = getValues('email_notication');
    if (!email_notification) {
      return showErrorToast('Debe ingresar un correo válido');
    }

    setLoadingEmail(true);
    try {
      const response: any = await generalApi.post('/users/config-correo', {
        accion: 'G',
        type: 'subsidy',
        email_notification,
      });

      if (response?.data?.status) {
        showSuccessToast('Correo de notificaciones actualizado correctamente');
      } else {
        showErrorToast('No se pudo actualizar el correo');
      }
    } catch (err) {
      showErrorToast('Error al actualizar el correo');
    } finally {
      setLoadingEmail(false);
    }
  };

  const buildBaseInput = (
    label: string,
    type: React.HTMLInputTypeAttribute,
    name: string,
    rules: any,
    props: any
  ) => {
    return (
      <BaseInput
        label={label}
        placeholder={`Ingrese su ${label}`}
        type={type}
        name={name}
        register={register}
        errors={errors}
        watch={watch}
        setValue={setValue}
        control={control}
        rules={rules}
        {...props}
      />
    );
  };

  return (
    <PrivateRoute>
      <form
        className="mx-auto h-full max-w-7xl px-1 pt-8 text-[#1B205A] lg:pt-24 lg:pb-8"
        onSubmit={handleSubmit(saveData)}
      >
        <div className="flex items-center justify-between">
          <h1 className="mb-4 text-xl font-bold text-primary-base sm:text-3xl">
            CONFIGURACIONES
          </h1>
        </div>
        {/* <p className="mt-8 mb-12">Ingresa tu contraseña actual y la nueva para cambiarla.</p>
        <div className="mx-auto flex max-w-sm flex-col gap-4">
          {buildBaseInput('Contraseña actual', 'password', 'password_now', REQUIRED_RULE, {})}
          {buildBaseInput('Nueva contraseña', 'password', 'password_new', REQUIRED_RULE, {})}

          <div className="mt-6">
            <SolidButton className="w-full" onClick={handleSubmit(saveData)} isLoading={loading}>
              Cambiar contraseña
            </SolidButton>
          </div>
        </div> */}
        <div className="grid grid-cols-2 gap-8 justify-center">
          {/* Izquierda */}
          <div className="flex flex-col gap-4 max-w-xs w-full">
            <p className="mt-8 mb-12">Ingresa tu contraseña actual y la nueva para cambiarla.</p>
            {buildBaseInput('Contraseña actual', 'password', 'password_now', REQUIRED_RULE, {})}
            {buildBaseInput('Nueva contraseña', 'password', 'password_new', REQUIRED_RULE, {})}

            <div className="mt-6">
              <SolidButton className="w-full" onClick={handleSubmit(saveData)} isLoading={loading}>
                Cambiar contraseña
              </SolidButton>
            </div>
          </div>

          {/* Derecha */}
          <div className="flex flex-col gap-4 max-w-xs w-full">
            <p className="mt-8 mb-12">Correo Notificaciones.</p>
            {buildBaseInput('Confirmar correo', 'email', 'email_notication', {}, {})}
            <div className="mt-6">
              <SolidButton className="w-full" onClick={saveEmail} isLoading={loadingEmail}>Cambiar correo</SolidButton>
            </div>
          </div>
        </div>
      </form>
    </PrivateRoute>
  );
}
